// src/services/firebase.js

import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const SECONDARY_AUTH_APP_NAME = 'LSCUserCreation';

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export { app };

/**
 * Firebase Auth used for `createUserWithEmailAndPassword` when the caller must stay signed in
 * (Contact Manager approve/promote, Admin create user). Secondary app auth does not replace the
 * primary session on the default app.
 */
export function getAuthForUserCreation({ preserveCallerSession = false } = {}) {
    if (!preserveCallerSession) return auth;
    let secondaryApp = getApps().find((a) => a.name === SECONDARY_AUTH_APP_NAME);
    if (!secondaryApp) {
        secondaryApp = initializeApp(firebaseConfig, SECONDARY_AUTH_APP_NAME);
    }
    return getAuth(secondaryApp);
}